import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./adminApi";
import { attachFallbacks } from "./projectImages";
import { FALLBACKS } from "./mock";
import { DEFAULT_CONTENT } from "./contentDefaults";

const SiteDataContext = createContext({
  projects: [],
  collections: [],
  categories: [],
  content: DEFAULT_CONTENT,
  loading: true,
  reload: () => {},
});

export function SiteDataProvider({ children }) {
  const [state, setState] = useState({
    projects: [],
    collections: [],
    categories: [],
    content: DEFAULT_CONTENT,
    loading: true,
  });

  const load = useCallback(() => {
    return Promise.all([api.projects(), api.collections(), api.categories(), api.content()])
      .then(([projects, collections, categories, content]) => {
        attachFallbacks(projects, FALLBACKS);
        setState({
          projects,
          collections,
          categories,
          content: { ...DEFAULT_CONTENT, ...content },
          loading: false,
        });
      })
      .catch(() => setState((s) => ({ ...s, loading: false })));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <SiteDataContext.Provider value={{ ...state, reload: load }}>{children}</SiteDataContext.Provider>;
}

export const useSiteData = () => useContext(SiteDataContext);
